<section class="comp-txn-error-code">

  <div *ngIf="request&&request.showStatusOnPage&&!request.showStatusInDialog">
    <div *ngIf="txnErrorCodes&&txnErrorCodes.length>0">
      <table class="table table-striped" style="width: 100%">
        <thead>
        <tr>
          <th style="width:2%">#</th>
          <th>Description</th>
          <th>Report To</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let errors of txnErrorCodes; let i=index">
          <td> {{ i + 1 }} </td>
          <td> {{errors.description}} </td>
          <td> {{errors.roleResponsible | titleCase}} </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="!txnErrorCodes||(txnErrorCodes&&txnErrorCodes.length<=0)">
      We are unable to display your errors
    </div>
  </div>

  <p-dialog header="Validation Error " [(visible)]="showTxnErrorCodes" [responsive]="true" modal="true" dismissableMask="true" appendTo="body"
            [style]="DialogStyle600">
    <div *ngIf="txnErrorCodes&&txnErrorCodes.length>0">
      <table class="table table-striped" style="width: 100%">
        <thead>
        <tr>
          <th style="width:2%">#</th>
          <th>Description</th>
          <th>Report To</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let errors of txnErrorCodes; let i=index">
          <td> {{ i + 1 }} </td>
          <td> {{errors.description}} </td>
          <td> {{errors.roleResponsible  | titleCase}} </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="!txnErrorCodes||(txnErrorCodes&&txnErrorCodes.length<=0)">
      We are unable to display your errors
    </div>

  </p-dialog>
</section>
